import cx from 'clsx';

import { DrawerProps } from './Drawer';
import drawerClasses from './Drawer.module.css';

//TO CHECK LATER
export const DRAWER_Z_INDEX = 300;

export const DrawerOverrideClassNames = (props: Partial<DrawerProps>) => {
  const { position, noPadding } = props;
  return {
    overlay: drawerClasses.overlay,
    body: cx(drawerClasses.body, {
      [drawerClasses.bodyWithoutPadding]: !!noPadding
    }),
    header: drawerClasses.header,
    title: drawerClasses.title,
    inner: drawerClasses.inner,
    content: cx(drawerClasses.content, {
      [drawerClasses.contentPosLeft]: position === 'left',
      [drawerClasses.contentPosRight]: position === 'right',
      [drawerClasses.contentPosTop]: position === 'top',
      [drawerClasses.contentPosBottom]: position === 'bottom'
    })
  };
};
